import dayjs from 'dayjs'

import 'dayjs/locale/en'
import 'dayjs/locale/hu'
import 'dayjs/locale/ko'
import 'dayjs/locale/zh'

dayjs.locale('en')

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
